var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { CreditCardTypesList } from "@travel/shared/types";
import { toTitleCase } from "../strings";
export function mutatePaymentMethod(data) {
    var _a, _b, _c;
    var id = (data === null || data === void 0 ? void 0 : data.cardId) || (data === null || data === void 0 ? void 0 : data.transactionId) || (data === null || data === void 0 ? void 0 : data.cvvAlias) || (data === null || data === void 0 ? void 0 : data.id);
    var expires = data === null || data === void 0 ? void 0 : data.expiry;
    if (expires && !String(expires).match("/")) {
        var month = expires.substring(0, 2);
        var year = expires.substring(2);
        expires = "".concat(month, "/").concat(year);
    }
    return {
        id: id,
        type: "CreditCard",
        card: {
            id: id,
            alias: data === null || data === void 0 ? void 0 : data.cardAlias,
            cvvAlias: data === null || data === void 0 ? void 0 : data.cvvAlias,
            name: data === null || data === void 0 ? void 0 : data.nameOnCard,
            brand: mutateCreditCardBrand(((_a = data === null || data === void 0 ? void 0 : data.cardInfo) === null || _a === void 0 ? void 0 : _a.brand) || (data === null || data === void 0 ? void 0 : data.brand)),
            type: mutateCreditCardType(((_b = data === null || data === void 0 ? void 0 : data.cardInfo) === null || _b === void 0 ? void 0 : _b.brand) || (data === null || data === void 0 ? void 0 : data.brand)),
            expires: expires || "".concat(data.expiryMonth, "/").concat(data.expiryYear),
            last4: ((_c = data === null || data === void 0 ? void 0 : data.maskedCard) === null || _c === void 0 ? void 0 : _c.slice(-4)) || (data === null || data === void 0 ? void 0 : data.last4) || "XXXX",
            billing: mutateAddress(data === null || data === void 0 ? void 0 : data.billingAddress),
        },
    };
}
export function mutateCreditCardBrand(type) {
    var e_1, _a;
    type = type.split(" ")[0];
    try {
        for (var CreditCardTypesList_1 = __values(CreditCardTypesList), CreditCardTypesList_1_1 = CreditCardTypesList_1.next(); !CreditCardTypesList_1_1.done; CreditCardTypesList_1_1 = CreditCardTypesList_1.next()) {
            var card = CreditCardTypesList_1_1.value;
            var id = card.id, name_1 = card.name;
            if (id == type ||
                name_1 === type ||
                (name_1 === null || name_1 === void 0 ? void 0 : name_1.replace(/\s/g, "").toUpperCase()) ===
                    (type === null || type === void 0 ? void 0 : type.replace(/\s/g, "").toUpperCase())) {
                return name_1;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (CreditCardTypesList_1_1 && !CreditCardTypesList_1_1.done && (_a = CreditCardTypesList_1.return)) _a.call(CreditCardTypesList_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return null;
}
export function mutateCreditCardType(type) {
    var e_2, _a;
    type = type.split(" ")[0];
    try {
        for (var CreditCardTypesList_2 = __values(CreditCardTypesList), CreditCardTypesList_2_1 = CreditCardTypesList_2.next(); !CreditCardTypesList_2_1.done; CreditCardTypesList_2_1 = CreditCardTypesList_2.next()) {
            var _b = CreditCardTypesList_2_1.value, id = _b.id, name_2 = _b.name;
            if (id == type ||
                name_2 === type ||
                name_2.replace(/\s/g, "").toUpperCase() ===
                    type.replace(/\s/g, "").toUpperCase()) {
                return id;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (CreditCardTypesList_2_1 && !CreditCardTypesList_2_1.done && (_a = CreditCardTypesList_2.return)) _a.call(CreditCardTypesList_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return null;
}
export function mutateTraveler(data) {
    return {
        id: (data === null || data === void 0 ? void 0 : data.id) || "",
        firstName: (data === null || data === void 0 ? void 0 : data.firstName) || "",
        lastName: (data === null || data === void 0 ? void 0 : data.lastName) || "",
        dateOfBirth: (data === null || data === void 0 ? void 0 : data.dob) || "",
    };
}
export function mutateAddress(address) {
    return {
        line1: (address === null || address === void 0 ? void 0 : address.address_line_one) || (address === null || address === void 0 ? void 0 : address.addressLineOne) || "",
        line2: (address === null || address === void 0 ? void 0 : address.address_line_two) || (address === null || address === void 0 ? void 0 : address.addressLineTwo) || "",
        city: toTitleCase((address === null || address === void 0 ? void 0 : address.city) || (address === null || address === void 0 ? void 0 : address.city_name) || ""),
        cityID: (address === null || address === void 0 ? void 0 : address.cityID) || "",
        country: (address === null || address === void 0 ? void 0 : address.country) || (address === null || address === void 0 ? void 0 : address.country_name) || "",
        countryCode: (address === null || address === void 0 ? void 0 : address.country_code) || (address === null || address === void 0 ? void 0 : address.country) || "",
        state: (address === null || address === void 0 ? void 0 : address.state) || (address === null || address === void 0 ? void 0 : address.state_name) || "",
        stateCode: (address === null || address === void 0 ? void 0 : address.state_code) || (address === null || address === void 0 ? void 0 : address.state) || "",
        postalCode: (address === null || address === void 0 ? void 0 : address.postal_code) || (address === null || address === void 0 ? void 0 : address.postalCode) || "",
        display: (address === null || address === void 0 ? void 0 : address.address_display) || (address === null || address === void 0 ? void 0 : address.hotel_address),
        latitude: !isNaN(address === null || address === void 0 ? void 0 : address.latitude) ? Number(address === null || address === void 0 ? void 0 : address.latitude) : undefined,
        longitude: !isNaN(address === null || address === void 0 ? void 0 : address.longitude)
            ? Number(address === null || address === void 0 ? void 0 : address.longitude)
            : undefined,
    };
}
